import React, { useEffect, useRef, useState } from 'react'
import Modal from '../Modal/Modal'
import Button from '../Buttons/Button'
import styled from 'styled-components'
import ErrorIcon from '../Icons/components/ErrorIcon'
import { Link } from 'react-router-dom'

const BUFFER_SIZE = 15;

// Drop this in any view to block the browser back button: it pads window.history
// with dummy states on mount, then intercepts 'popstate' (and bfcache 'pageshow')
// to re-push the current state and show a confirmation modal instead of navigating away.
const PreventGoingBack = ({
    active = true,
    onBack,
    title = 'Nie można wrócić do poprzedniej strony',
    description = 'Twoje dane zostały pobrane z aplikacji mObywatel. Jezeli chcesz je zmienić rozpocznij składanie nowego wniosku.',
    confirmLabel = 'Zamknij',
    secondaryLabel = 'Nowy wniosek',
    secondaryTo = '/basket',
}) => {
    const [show, setShow] = useState(false);
    const bufferInstalled = useRef(false);

    useEffect(() => {
        if (!active) return;

        if (!bufferInstalled.current) {
            const clean = window.location.pathname;
            window.history.replaceState(null, '', clean);
            for (let i = 0; i < BUFFER_SIZE; i += 1) {
                window.history.pushState(null, '', clean);
            }
            bufferInstalled.current = true;
        }

        const blockBack = () => {
            window.history.pushState(null, '', window.location.pathname);
            setShow(true);
            onBack?.();
        };
        const onPageShow = (e) => { if (e.persisted) blockBack(); };

        window.addEventListener('popstate', blockBack);
        window.addEventListener('pageshow', onPageShow);

        return () => {
            window.removeEventListener('popstate', blockBack);
            window.removeEventListener('pageshow', onPageShow);
        };
    }, [active, onBack]);

    const closeModal = () => setShow(false);

    return (
        <Modal show={show} closeModal={closeModal}>
            <ModalContent>
                <IconContainer>
                    <ErrorIcon style={{ width: '100px', height: '100px', margin: 'auto' }}/>
                </IconContainer>
                <TitleModal>{title}</TitleModal>
                <Description>{description}</Description>
                <Button buttonType='primary' onClick={closeModal}>{confirmLabel}</Button>
                {secondaryLabel && secondaryTo && (
                    <Link to={secondaryTo}>
                        <Button buttonType='outline' onClick={closeModal}>{secondaryLabel}</Button>
                    </Link>
                )}
            </ModalContent>
        </Modal>
    )
}

export default PreventGoingBack

const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 10px;
`

const TitleModal = styled.div`
    font-size: 20px;
    color: black;
    font-weight: bold;
    text-align: center;
`

const Description = styled.div`
    font-size: 16px;
    color: black;
    text-align: center;
    line-height: 25px;
`

const IconContainer = styled.div`
    font-size: 70px;
    text-align: center;
    svg {
        display: block;
        margin: auto;
    }
`;
